import React from 'react';
import { HasClassName } from '../component-utils';
import { CallState, MediaType } from '../model';
import { ReactComponent as OutBoundMeidaIcon } from './icons/media/outbound.svg';
import { ReactComponent as CallBackMeidaIcon } from './icons/media/callback.svg';
import { ReactComponent as EmailMeidaIcon } from './icons/media/email.svg';
import { ReactComponent as EmailMeidaOpenIcon } from './icons/media/email-open.svg';
import { ReactComponent as EmailMeidaHeldIcon } from './icons/media/email-open.svg';
import { ReactComponent as FacebookMeidaIcon } from './icons/media/facebook.svg';
import { ReactComponent as TwitterMeidaIcon } from './icons/media/tweet.svg';
import { ReactComponent as WebChatMeidaIcon } from './icons/media/web-chat.svg';
import { ReactComponent as CallMeidaIcon } from './icons/media/call.svg';

import { ReactComponent as OutBoundMeidaWhiteIcon } from './icons/media/outbound-white.svg';
import { ReactComponent as CallBackMeidaWhiteIcon } from './icons/media/callback-white.svg';
import { ReactComponent as EmailMeidaWhiteIcon } from './icons/media/email-white.svg';
import { ReactComponent as EmailMeidaOpenWhiteIcon } from './icons/media/email-open-white.svg';
import { ReactComponent as EmailMeidaHeldWhiteIcon } from './icons/media/email-open-white.svg';
import { ReactComponent as FacebookMeidaWhiteIcon } from './icons/media/facebook-white.svg';
import { ReactComponent as TwitterMeidaWhiteIcon } from './icons/media/tweet-white.svg';
import { ReactComponent as WebChatMeidaWhiteIcon } from './icons/media/web-chat-white.svg';
import { ReactComponent as CallMeidaWhiteIcon } from './icons/media/call-white.svg';

export enum MediaItemIconType {
  white,
  color
}

interface Props extends HasClassName {
  mediaType: MediaType,
  iconType?: MediaItemIconType,
  title?: string | boolean,
  callStatus?: CallState,
  onClick?(e: React.MouseEvent): void
}

export default function MediaIcon({ className, mediaType, iconType, callStatus, title, onClick }: Props) {
  return React.cloneElement(getIconByMediaType(mediaType, iconType, callStatus, title, onClick), { className });
}

function getIconByMediaType(type: MediaType, iconType?: MediaItemIconType, callStatus?: CallState, title?: string | boolean, onClick?: (e: React.MouseEvent) => void) {
  function handleClick(e: React.MouseEvent) {

    e.preventDefault()

    if (onClick) {
      onClick(e)
    }
  }

  const pointer = { cursor: 'pointer' }

  switch (type) {
    case 'TC':
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Web Chat'} onClick={onClick && handleClick} style={pointer}>{iconType === MediaItemIconType.white ? <WebChatMeidaWhiteIcon /> : <WebChatMeidaIcon />} </div>;
    case 'EMAIL':
      if (callStatus)
        if (callStatus === CallState.Hold) {
          return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Email on hold'} onClick={onClick && handleClick} style={pointer}>{iconType === MediaItemIconType.white ? <EmailMeidaHeldWhiteIcon /> : <EmailMeidaHeldIcon />}</div>;
        } else if (callStatus === CallState.ExtensionAnswered) {
          return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Email answered'} onClick={onClick && handleClick} style={pointer}>{iconType === MediaItemIconType.white ? <EmailMeidaOpenWhiteIcon /> : <EmailMeidaOpenIcon />}</div>;
        }
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Email'} onClick={onClick && handleClick} style={pointer} >{iconType === MediaItemIconType.white ? <EmailMeidaWhiteIcon /> : <EmailMeidaIcon />}</div>;
    case 'FB':
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Facebook'} onClick={onClick && handleClick} style={pointer}>{iconType === MediaItemIconType.white ? <FacebookMeidaWhiteIcon /> : <FacebookMeidaIcon />}</div>;
    case 'TWEET':
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Twitter'} onClick={onClick && handleClick} style={pointer}>{iconType === MediaItemIconType.white ? <TwitterMeidaWhiteIcon /> : <TwitterMeidaIcon />}</div>;
    case 'VM':
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Web Call'} onClick={onClick && handleClick} style={pointer}>{iconType === MediaItemIconType.white ? <CallBackMeidaWhiteIcon /> : <CallBackMeidaIcon />}</div>;
    case 'OUT':
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Outbound'} onClick={onClick && handleClick} style={pointer} >{iconType === MediaItemIconType.white ? <OutBoundMeidaWhiteIcon /> : <OutBoundMeidaIcon />}</div>;

    default:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Call'} onClick={onClick && handleClick} style={pointer} >{iconType === MediaItemIconType.white ? <CallMeidaWhiteIcon /> : <CallMeidaIcon />}</div>;
  }
}
